export default __webpack_public_path__ + "static/media/1040.c841a9a7.png";